import { motion } from "framer-motion";
import { IMAGES } from "@/data/site";

const KIT = [
  {
    title: "Expedition Racks",
    body: "Heavy-duty roof racks rated for real loads, a Yakima Mega-Warrior basket, and a custom-fabricated hatch-mounted bike rack. Carry bikes, boards, boxes — the full expedition load.",
    tag: "Optional extra",
    image: IMAGES.redwoods,
    alt: "Hatch-mounted bike rack loaded, redwoods behind",
  },
  {
    title: "Rooftop Tent",
    body: "A fold-out triple berth that mounts to the racks. Ninety seconds from parked to asleep, above the mud and the morning dew.",
    tag: "Optional extra",
    image: IMAGES.tepui,
    alt: "Tepui rooftop tent open with ladder down, rear view of the van",
  },
];

export default function Extras() {
  return (
    <section id="expedition-kit" className="bg-secondary text-secondary-foreground py-24 md:py-40" data-testid="extras-section">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 md:mb-20"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-4">Take it further</p>
          <h2 className="font-headings uppercase text-5xl md:text-7xl leading-[0.85]">
            The Expedition<br /><span className="text-accent">Kit</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 md:gap-6">
          {KIT.map((k, i) => (
            <motion.article
              key={k.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group border border-secondary-foreground/20"
              data-testid={`extra-card-${i}`}
            >
              <div className="overflow-hidden">
                <img
                  src={k.image}
                  alt={k.alt}
                  loading="lazy"
                  className="w-full h-auto img-warm"
                />
              </div>
              <div className="p-6 md:p-10">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-accent mb-3">{k.tag}</p>
                <h3 className="font-headings uppercase text-3xl md:text-4xl mb-4">{k.title}</h3>
                <p className="text-secondary-foreground/70 leading-relaxed">{k.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
